import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, Navigate, useParams, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import * as CONST from "../config/Constant";
import { toast } from "react-toastify";
import AuthMenu from "./AuthMenu";
import WithoutAuthMenu from "./WithoutAuthMenu";
import axios from "axios";
import { FiUser, FiCalendar, FiClock, FiDollarSign, FiBox, FiFileText, FiEdit, FiLogOut, FiAlertCircle, FiMessageSquare, FiCreditCard, FiBell } from "react-icons/fi";
function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSticky, setSticky] = useState(false);
  const [authUserData, setAuthUserData] = useContext(AuthContext);

  // FIX: These must be useState, not plain let variables.
  // On login redirect, authUserData is null on first render.
  // Plain variables would stay empty and never trigger a re-render.
  // With useState + useEffect([authUserData]), the Header properly
  // re-renders when the context populates, showing AuthMenu correctly.
  const [isToken, setIsToken] = useState("");
  const [profile_photo_path, setProfilePhotoPath] = useState("");
  const [first_name, setFirstName] = useState("");
  const [first_name_short, setFirstNameShort] = useState("");
  const [last_name_short, setLastNameShort] = useState("");
  const [isAdmin, setIsAdmin] = useState(0);
  const [isHead, setIsHead] = useState(0);
  const [userId, setUserId] = useState("");
  const [deptId, setDeptId] = useState("");
  const [notifCounts, setNotifCounts] = useState({ pending_approvals: 0, pending_handovers: 0, open_requests: 0, unread_total: 0 });

  useEffect(() => {
    if (authUserData && authUserData[0]) {
      const user = authUserData[0];
      setFirstNameShort(user.first_name ? user.first_name.substring(0, 1) : "");
      setLastNameShort(user.last_name ? user.last_name.substring(0, 1) : "");
      setFirstName(user.first_name ?? "");
      setProfilePhotoPath(user.profile_photo_path ?? "");
      setIsToken(user.token ?? "");
      setIsAdmin(user.is_admin || 0);
      setIsHead(user.is_head || 0);
      setUserId(user.user_id || "");
      setDeptId(user.department_id || "");
    } else {
      // Logged out — reset all values
      setIsToken("");
      setFirstName("");
      setFirstNameShort("");
      setLastNameShort("");
      setProfilePhotoPath("");
    }
  }, [authUserData]);

  // Fetch notification counts
  useEffect(() => {
    if (isToken && userId) {
      axios.post(CONST.GET_NOTIFICATION_COUNTS, {
        user_id: userId, is_admin: isAdmin, is_head: isHead, department_id: deptId
      }, { headers: { Authorization: `Bearer ${isToken}` } })
      .then(res => { if (res.data.status === 'success') setNotifCounts(res.data.data); })
      .catch(() => {});

      // Refresh every 60 seconds
      const interval = setInterval(() => {
        axios.post(CONST.GET_NOTIFICATION_COUNTS, {
          user_id: userId, is_admin: isAdmin, is_head: isHead, department_id: deptId
        }, { headers: { Authorization: `Bearer ${isToken}` } })
        .then(res => { if (res.data.status === 'success') setNotifCounts(res.data.data); })
        .catch(() => {});
      }, 60000);
      return () => clearInterval(interval);
    }
  }, [isToken, userId]);

  const profileImage = CONST.HOST + profile_photo_path;
  console.log(profileImage);
  const handleScroll = () => {
    const windowScrollTop = window.scrollY;
    if (windowScrollTop > 10) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Close all open dropdown/collapse menus on route change
  useEffect(() => {
    const openMenus = document.querySelectorAll(".sub-menu.collapse.show, .mega_menu.collapse.show");
    openMenus.forEach((menu) => menu.classList.remove("show"));
  }, [location.pathname]);

  const handleLogout = () => {
    navigate("/");
    const UserData = [
      {
        first_name: "",
        last_name: "",
        email: "",
        status: "",
        token: "",
        role_id: "",
        profile_photo_path: "",
      },
    ];
    setAuthUserData(UserData);
    localStorage.removeItem("eToken");
    toast.success("You have logged out successfully.");
  };
  const pathName = window.location.pathname;
  const adminPath = "admin";
  const isAdminPanel = pathName.includes(adminPath);

  return (
    <>
      <header className="header header-4">
        <div className="navbar-area">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <nav className="navbar navbar-expand-lg">
                  <Link className="navbar-brand" to="/">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/eluminous-pvt-ltd.png"
                      }
                      alt="logo"
                    />
                  </Link>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent4"
                    aria-controls="navbarSupportedContent4"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="toggler-icon"></span>
                    <span className="toggler-icon"></span>
                    <span className="toggler-icon"></span>
                  </button>
                  <div
                    className="collapse navbar-collapse sub-menu-bar"
                    id="navbarSupportedContent4"
                  >
                    <ul id="nav4" className="navbar-nav ml-auto">
                      {isToken ? (
                        <>
                          <li className="nav-item">
                            <Link
                              className="page-scroll"
                              aria-current="page"
                              to={CONST.ADMIN_PRE + "dashboard"}
                            >
                              Dashboard
                            </Link>
                          </li>
                          {isAdminPanel ? (
                            <>
                              <AuthMenu />
                            </>
                          ) : (
                            <>
                              <WithoutAuthMenu />
                            </>
                          )}
                          {/* Notification Bell */}
                          <li className="nav-item dropdown" style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}>
                            <Link
                              className="page-scroll"
                              href="#"
                              data-toggle="collapse"
                              data-target="#notification-dropdown"
                              aria-controls="notification-dropdown"
                              aria-expanded="false"
                              style={{ position: 'relative', padding: '6px' }}
                            >
                              <FiBell size={20} style={{ color: '#475569' }} />
                              {notifCounts.unread_total > 0 && (
                                <span style={{
                                  position: 'absolute', top: 0, right: -2,
                                  background: '#dc2626', color: '#fff', borderRadius: '50%',
                                  width: 18, height: 18, fontSize: '0.65rem', fontWeight: 700,
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>{notifCounts.unread_total}</span>
                              )}
                            </Link>
                            <ul className="sub-menu collapse" id="notification-dropdown" style={{ minWidth: 250, right: 0, left: 'auto' }}>
                              <li style={{ padding: '8px 16px', borderBottom: '1px solid #f1f5f9', fontWeight: 700, fontSize: '0.85rem', color: '#0a1628' }}>Notifications</li>
                              {notifCounts.pending_approval > 0 && (
                                <li><Link to={CONST.ADMIN_PRE + "requests/all"} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 16px', fontSize: '0.82rem' }}>
                                  <span>Pending Approvals</span>
                                  <span style={{ background: '#dc2626', color: '#fff', borderRadius: 10, padding: '0 8px', fontSize: '0.7rem', fontWeight: 700 }}>{notifCounts.pending_approval}</span>
                                </Link></li>
                              )}
                              {notifCounts.pending_leaves > 0 && (
                                <li><Link to={CONST.ADMIN_PRE + "employee/leaves/all"} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 16px', fontSize: '0.82rem' }}>
                                  <span>Pending Leaves</span>
                                  <span style={{ background: '#d97706', color: '#fff', borderRadius: 10, padding: '0 8px', fontSize: '0.7rem', fontWeight: 700 }}>{notifCounts.pending_leaves}</span>
                                </Link></li>
                              )}
                              {notifCounts.pending_compoff > 0 && (
                                <li><Link to={CONST.ADMIN_PRE + "employee/comp-off/all"} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 16px', fontSize: '0.82rem' }}>
                                  <span>Pending Comp-Off</span>
                                  <span style={{ background: '#7c3aed', color: '#fff', borderRadius: 10, padding: '0 8px', fontSize: '0.7rem', fontWeight: 700 }}>{notifCounts.pending_compoff}</span>
                                </Link></li>
                              )}
                              {notifCounts.open_requests > 0 && (
                                <li><Link to={CONST.ADMIN_PRE + "requests/all"} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 16px', fontSize: '0.82rem' }}>
                                  <span>New Requests</span>
                                  <span style={{ background: '#1e40af', color: '#fff', borderRadius: 10, padding: '0 8px', fontSize: '0.7rem', fontWeight: 700 }}>{notifCounts.open_requests}</span>
                                </Link></li>
                              )}
                              {notifCounts.pending_handovers > 0 && (
                                <li><Link to={CONST.ADMIN_PRE + "requests/my"} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 16px', fontSize: '0.82rem' }}>
                                  <span>Pending Handovers</span>
                                  <span style={{ background: '#059669', color: '#fff', borderRadius: 10, padding: '0 8px', fontSize: '0.7rem', fontWeight: 700 }}>{notifCounts.pending_handovers}</span>
                                </Link></li>
                              )}
                              {notifCounts.unread_total === 0 && (
                                <li style={{ padding: '12px 16px', fontSize: '0.82rem', color: '#94a3b8', textAlign: 'center' }}>No pending notifications</li>
                              )}
                            </ul>
                          </li>
                          <li className="nav-item dropdown nav-item last_profile d-flex flex-wrap">
                            <span
                              className="rounded-circle pr-2"
                              style={{
                                backgroundImage: `url("${
                                  CONST.HOST + profile_photo_path
                                }")`,
                              }}
                            ></span>
                            <Link
                              className="page-scroll "
                              href="#0"
                              data-toggle="collapse"
                              data-target="#sub-nav2"
                              aria-controls="sub-nav2"
                              aria-expanded="false"
                              aria-label="Toggle navigation"
                            >
                              <span className="pl-1 pr-1">{first_name}</span>
                              <div className="sub-nav-toggler">
                                <span>
                                  <i className="lni lni-chevron-down"></i>{" "}
                                </span>
                              </div>
                            </Link>
                            <ul className="sub-menu collapse" id="sub-nav2">
                              <li><Link to={CONST.ADMIN_PRE + "account/profile"}><FiUser size={15} className="mr-2" /> My Profile</Link></li>
                              <li><Link to={CONST.ADMIN_PRE + "account/tax-exemptions"}><FiDollarSign size={15} className="mr-2" /> My Tax Exemptions</Link></li>
                              <li><Link to={CONST.ADMIN_PRE + "account/quiz"}><FiFileText size={15} className="mr-2" /> My Quiz</Link></li>
                              <li><Link to={CONST.ADMIN_PRE + "account/articles"}><FiEdit size={15} className="mr-2" /> Add Article</Link></li>
                              <li><Link to={CONST.ADMIN_PRE + "account/resignation"}><FiAlertCircle size={15} className="mr-2" /> Apply Resignation</Link></li>
                              <li>
                                <button className="nav-button button" onClick={handleLogout}>
                                  <i className="lni lni-lock"></i> &nbsp;Logout
                                </button>
                              </li>
                            </ul>
                          </li>
                        </>
                      ) : (
                        <>
                          <WithoutAuthMenu />
                        </>
                      )}
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
export default Header;
 